import React from "react";
import { useSettings } from "../context/SettingsContext";
import { Heart } from "lucide-react";

export default function AnnouncementBar() {
    const { settings } = useSettings();
    const text = settings?.announcementText || "Free shipping on orders above ₹1499";
    return (
        <div className="bg-sage-400 text-white text-[11px] sm:text-xs text-center py-2.5 tracking-[0.25em] uppercase font-medium" data-testid="announcement-bar">
            <span className="inline-flex items-center gap-2">
                <Heart size={12} strokeWidth={2} className="opacity-90" />
                {text}
            </span>
        </div>
    );
}
